import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/Button";
import Seo from "../components/Seo";

const NotFound = () => (
  <>
    <Seo title="404 | OnSports" description="Pagina non trovata" path="/404" />
    <section className="min-h-screen bg-dodgers text-galactico flex items-center" data-testid="not-found">
      <div className="container-os text-center">
        <span className="font-display block leading-none text-lime" style={{ fontSize: "clamp(8rem, 30vw, 22rem)" }}>
          404
        </span>
        <h1 className="display-h2 mt-6 max-w-[24ch] mx-auto">Questa pagina non esiste — o non genera ancora impatto.</h1>
        <p className="mt-7 body-lg opacity-85 max-w-[50ch] mx-auto">
          Torna in homepage e scopri come trasformiamo lo sport in impatto misurabile.
        </p>
        <div className="mt-10 inline-block">
          <Link to="/">
            <Button variant="primary">Torna alla home</Button>
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
